import { useField } from 'formik';
import { Input } from 'semantic-ui-react';
import FieldWrapper from 'components/Form/Fields/FieldWrapper';

export default function InputField({ label, ...props }) {
  const [field, meta] = useField(props);

  return (
    <FieldWrapper props={props} meta={meta} label={label}>
      <Input {...field} {...props} className="form-field__input-text" />
    </FieldWrapper>
  );
}
